export default __webpack_public_path__ + "static/media/Snd_Try3.198ef2b6.mp3";